export default "__VITE_ASSET__r4lan59w__ 100w";